import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const CURRENT_DEPLOYMENT: ComboBoxItem<string>[] = [
  { id: 0, label: "We have not deployed any models yet", value: "None" },
  {
    id: 1,
    label: "On-Premise Servers (without GPUs)",
    value: "On-Premise Servers (without GPUs)",
  },
  {
    id: 2,
    label: "On-Premise Servers (with GPUs)",
    value: "On-Premise Servers (with GPUs)",
  },
  { id: 3, label: "Amazon Web Services", value: "AWS" },
  { id: 4, label: "Google Cloud Platform", value: "GCP" },
  { id: 5, label: "Microsoft Azure", value: "Microsoft Azure" },
  { id: 6, label: "Runpods.io", value: "Runpods.io" },
  { id: 7, label: "Others", value: "Others" },
];

export default CURRENT_DEPLOYMENT;
